import React from 'react';
import { Phone, CheckCircle2 } from 'lucide-react';
import { QuoteQuiz } from './QuoteQuiz';
export function CTASection() {
  return <section id="quote-form" className="py-16 bg-primary/5 md:py-24" data-id="element-257">
      <div className="container mx-auto px-4 md:px-6" data-id="element-258">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-259">
          <div className="space-y-8" data-id="element-260">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-261">
              Ready to Say Goodbye to Shovelling?
            </h2>
            <p className="text-lg text-slate-600" data-id="element-262">
              Get a free, no-obligation recommendation for your home. Our
              interactive tool will help you find the perfect system, material,
              and finish for your property.
            </p>

            <div className="space-y-4" data-id="element-263">
              <div className="flex items-center gap-3" data-id="element-264">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0" data-id="element-265">
                  <Phone className="h-5 w-5 text-primary" data-id="element-266" />
                </div>
                <div data-id="element-267">
                  <p className="text-sm font-medium text-slate-500" data-id="element-268">
                    Prefer to call?
                  </p>
                  <a href="tel:647-706-9908" className="text-xl font-bold text-slate-900 hover:text-primary" data-id="element-269">
                    (647) 706-9908
                  </a>
                </div>
              </div>
            </div>

            <div className="p-6 bg-white rounded-xl border shadow-sm" data-id="element-270">
              <h4 className="font-semibold text-slate-900 mb-2" data-id="element-271">
                Why use our recommendation tool?
              </h4>
              <ul className="space-y-2 text-sm text-slate-600" data-id="element-272">
                <li className="flex items-center gap-2" data-id="element-273">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-274" />
                  Instant personalized system matching
                </li>
                <li className="flex items-center gap-2" data-id="element-275">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-276" />
                  Compare materials and finishes
                </li>
                <li className="flex items-center gap-2" data-id="element-277">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-278" />
                  Get a detailed quote sent to your inbox
                </li>
              </ul>
            </div>
          </div>

          <div className="space-y-6" data-id="element-279">
            <QuoteQuiz data-id="element-280" />
          </div>
        </div>
      </div>
    </section>;
}